export function openExternalUrl(url, fallback) {
  try {
    const normalizedUrl = new URL(url.replace(/\u200B/g, '').trim());
    
    if (normalizedUrl.protocol !== 'https:') {
      console.warn('URL is not using HTTPS:', normalizedUrl.href);
    }
    
    window.open(normalizedUrl.href, "_blank", "noopener,noreferrer");
    return true;
  } catch (error) {
    console.error('Invalid URL:', error);
    if (fallback) {
      fallback();
    }
    return false;
  }
} 